/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";

export const DateTimeFieldViewer = props => {
	const {Value: value, FieldDef: fieldDef = {}} = props;
	const {customData = {}} = fieldDef;
	const {
		format = 'MMMM d, yyyy h:mm a',
		nullDisplayValue = "",
	} = customData;
	return value ? DateUtils.FormatToLocalDate(value, format) : nullDisplayValue;
}
